import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { apiFetch, ApiError } from "../client";
import type { Invite } from "../types";

export function invitesKey(slug: string) {
  return ["invites", slug] as const;
}

export function useInvites(slug: string): UseQueryResult<Invite[], ApiError> {
  return useQuery<Invite[], ApiError>({
    queryKey: invitesKey(slug),
    queryFn: ({ signal }) => apiFetch<Invite[]>(`/api/ws/${slug}/invites`, { signal }),
    enabled: !!slug,
  });
}
